// 01 — what we know. One row per fact from the data layer.
import type { Fact } from '../types';
import { IconTile, MONO, Section, SectionHead } from './primitives';

export function SectionKnown({ facts }: { facts: Fact[] }) {
  return (
    <Section label="01 what we know">
      <SectionHead numeral="01 — what we know" title="decisions go here" />
      {facts.map((fact) => (
        <div
          key={fact.k}
          style={{
            display: 'flex',
            gap: 16,
            alignItems: 'center',
            padding: '16px 0',
            borderBottom: '1px solid var(--hairline)',
          }}
        >
          <IconTile icon={fact.icon} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'baseline',
                gap: 10,
                fontFamily: MONO,
                fontSize: 12,
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                color: 'var(--muted-2)',
              }}
            >
              <span>{fact.k}</span>
              {fact.note && <span style={{ color: 'var(--orange)' }}>· {fact.note}</span>}
            </div>
            <div
              style={{
                fontSize: 'clamp(21px,5vw,24px)',
                fontWeight: 600,
                letterSpacing: '-0.02em',
                lineHeight: 1.25,
                color: 'var(--bone)',
              }}
            >
              {fact.v}
            </div>
          </div>
        </div>
      ))}
      <p
        style={{
          fontFamily: MONO,
          fontSize: 14,
          lineHeight: 1.6,
          color: 'var(--muted)',
          borderLeft: '2px solid var(--orange)',
          paddingLeft: 14,
          margin: '22px 0 0',
        }}
      >
        this will get updated as things are finalized
      </p>
    </Section>
  );
}
